export const tujuan_laporan = {
  router: [
    {
      name: "TUJUAN LAPORAN",
      key: "tujuan_laporan",
      path: "/admin/master/tujuan-laporan",
      apiUrl: {
        data: "master/api/tujuan/laporan/",
        preview: "master/api/tujuan/laporan/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "TUJUAN LAPORAN",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
